import { OrderListReference } from '@1po/1po-bff-fe-spec/generated/order_list/model/OrderListReference';
import { CreateOrderList } from 'domains/orderList/OrderList.types';

export function getOrderListReferences(orderList: CreateOrderList): OrderListReference[] {
  return [...orderList.references].filter((ref) => ref.referenceNumber) as OrderListReference[];
}
